import { observer } from "mobx-react";
import { Input } from "../../../../../../../../../components/inputs/input/input";
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { ICompareValueTypeComponentProps } from "../condition-field";
import FloatCompareValueStore from "../../../../../../../stores/compare-value/float-compare-value-store";

const FloatCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore = store as FloatCompareValueStore;

    return (
        <>
            {operatorSelector}

            <Input disabled={!condition.isEditMode} type={'number'} min={0} value={compareValueStore.value} onChange={(v) => compareValueStore.setValue(v as number)} placeholder="0.00" />

            {condition.text && <FontBody2>{condition.text}</FontBody2>}
        </>
    );
});

export default FloatCompareValueField;